<template>
    <div>
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb" v-show="!onCheckoutPage">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Terms & Conditions
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="cmn-section terms-conditions mb_60 mt_10">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="terms-conditions-heading">
                            Terms & Conditions
                        </h1>
                    </div>
                    <div class="col-md-12">
                        <div v-if="hasTerms" v-html="termsHtml"></div>
                        <div v-else class="not-updated">Not Updated</div>
                    </div>
                </div>
            </div>
        </section>

        <div class="preloader" v-show="loading">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0"></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "TermsConditions",
    props: ["onCheckoutPage"],
    components: {},
    data() {
        return {
            termsHtml: "",
            loading: false
        };
    },
    computed: {
        hasTerms() {
            return !!(this.termsHtml && String(this.termsHtml).replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim());
        }
    },
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        this.loadTerms();
    },
    methods: {
        async loadTerms() {
            this.loading = true;
            try {
                const res = await ApiService.query("terms-conditions", { params: {} });
                this.termsHtml = (res.data && res.data.terms && res.data.terms.content) || "";
            } catch (e) {
                this.termsHtml = "";
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.not-updated {
    font-size: 16px;
    color: #6b7280;
    padding: 10px 0;
}
</style>
